import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-2 _h-full _pt-4" }
const _hoisted_2 = {
  key: 1,
  class: "_flex _flexwrap _gap-1 _mt-a"
}
const _hoisted_3 = {
  key: 2,
  class: "_flex _flexwrap _gap-4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_partner_image = _resolveComponent("partner-image")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_tag = _resolveComponent("base-tag")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, {
    tag: "article",
    orientation: "vertical",
    class: "gfu-partner-card",
    "data-qa": `partner-card-ID:${$props.partner.partnerID}`
  }, _createSlots({
    media: _withCtx(() => [
      ($options.hasGallery)
        ? (_openBlock(), _createBlock(_component_base_carousel, {
            key: 0,
            class: "gfu-partner-card__gallery"
          }, {
            default: _withCtx(({ currentItem }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.galleryImageUrls, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(['gfu-partner-card__slide', { 'is-active': currentItem === index }]),
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.onOpen && $options.onOpen(...args)))
                }, [
                  _createVNode(_component_base_image, {
                    src: image,
                    alt: $props.partner.name,
                    class: "gfu-partner-card__image"
                  }, null, 8 /* PROPS */, ["src", "alt"])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            nav: _withCtx(({ onNext, onPrev }) => [
              _createVNode(_component_base_carousel_navigation, {
                type: "prev",
                icon: "angle-left",
                class: "gfu-partner-card__gallery-nav _posl-2",
                onClick: onPrev,
                "data-qa": "partner-card-gallery:Previous"
              }, null, 8 /* PROPS */, ["onClick"]),
              _createVNode(_component_base_carousel_navigation, {
                type: "next",
                icon: "angle-right",
                class: "gfu-partner-card__gallery-nav _posr-2",
                onClick: onNext,
                "data-qa": "partner-card-gallery:Next"
              }, null, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "gfu-partner-card__gallery",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.onOpen && $options.onOpen(...args)))
          }, [
            _createVNode(_component_partner_image, {
              alt: $props.partner.name,
              class: "gfu-partner-card__image"
            }, null, 8 /* PROPS */, ["alt"])
          ])),
      _createElementVNode("button", {
        type: "button",
        class: "gfu-partner-card__logo",
        onClick: _cache[2] || (_cache[2] = (...args) => ($options.onOpen && $options.onOpen(...args))),
        "data-qa": "partner-card:OpenLogo"
      }, [
        _createVNode(_component_partner_image, {
          src: $options.logoUrl,
          alt: $props.partner.name,
          class: "gfu-partner-card__logo-image"
        }, null, 8 /* PROPS */, ["src", "alt"])
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_title, {
          level: "h3",
          class: "gfu-partner-card__name",
          onClick: $options.onOpen,
          "data-qa": "partner-card:OpenName"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.partner.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]),
        ($props.partner.description)
          ? (_openBlock(), _createBlock(_component_base_text, {
              key: 0,
              class: "gfu-partner-card__description"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.partner.description), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        ($options.categoryTags.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categoryTags, (tag) => {
                return (_openBlock(), _createBlock(_component_base_tag, {
                  key: tag.id,
                  tag: "button",
                  type: "button",
                  theme: "accent",
                  class: "_ma-0",
                  onClick: $event => ($options.onCategoryClick(tag.id)),
                  "data-qa": `partner-card-category:${tag.id}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($options.keyMetrics.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.keyMetrics, (metric) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: metric.name,
                  class: "_flexcol _mw-0 _wbbw"
                }, [
                  _createVNode(_component_base_text, {
                    as: "span",
                    level: "caption",
                    class: "_ttu _tc--light"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(metric.name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_base_text, {
                    as: "span",
                    class: "_fw-b"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(metric.value), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($options.hasSpecialBadge)
      ? {
          name: "labels",
          fn: _withCtx(() => [
            _createVNode(_component_base_badge, {
              theme: "primary",
              "data-qa": "partner-card:Badge"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.specialBadgeName), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-qa"]))
}